import { render, staticRenderFns } from "./TheDocumentNotes.vue?vue&type=template&id=a201076c&scoped=true&"
import script from "./TheDocumentNotes.vue?vue&type=script&lang=js&"
export * from "./TheDocumentNotes.vue?vue&type=script&lang=js&"
import style0 from "./TheDocumentNotes.vue?vue&type=style&index=0&id=a201076c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a201076c",
  null
  
)

export default component.exports